app.controller("EmployeeIncomingDocumentsController", [
    "$scope", "$stateParams", "StaticData", "DocumentsService", "Students", "Socket", "$state", "usSpinnerService", "toastr",
    function ($scope, $stateParams, StaticData, DocumentsService, Students, Socket, $state, usSpinnerService, toastr) {
        $scope.documents = [];
        $scope.workerId = null;
        $scope.totalItems = 0;
        $scope.currentDocsCount = 0;
        $scope.itemsPerPage = 20;
        $scope.format = "dd-MM-yyyy";
        $scope.query = $stateParams.query || null;
        $scope.type = $stateParams.type || null;
        $scope.parentType = $stateParams.parentType || null;
        $scope.authorOrg = $stateParams.authorOrg || null;
        $scope.state = $stateParams.state;
        $scope.actionRequired = $stateParams.actionRequired === 'true' || null;
        $scope.authorEmp = $stateParams.authorEmp || null;
        $scope.authorSt = $stateParams.authorSt || null;
        $scope.uniqueNumber = $stateParams.uniqueNumber || null;
        $scope.fromDate = $stateParams.fromDate ? new Date($stateParams.fromDate) : null;
        $scope.toDate = $stateParams.toDate ? new Date($stateParams.toDate) : null;
        $scope.documentTypes = {
            'INNER': {
                active: [],
                deleted: []
            },
            'STUDENT_INNER': {
                active: [],
                deleted: []
            },
            'OUTER': {
                active: [],
                deleted: []
            },
            'OUTGOING': {
                active: [],
                deleted: []
            },
            'OTHER': {
                active: [],
                deleted: []
            },
        };

        $scope.today = new Date();

        $scope.states = [
            { name: 'წაუკითხავი', _id: 'unread' },
            { name: 'წაკითხული', _id: 'read' },
            { name: 'შესრულებული', _id: 'done' },
            { name: 'მიბრუნებული', _id: 'returned' },
            { name: 'გადამისამართებული', _id: 'resolved' }
        ];

        $scope.popup1 = {
            opened: false
        };

        $scope.popup2 = {
            opened: false
        };

        $scope.fromDateOptions = {
            maxDate: new Date()
        };

        $scope.openFromDate = function () {
            $scope.popup1.opened = true;
        };

        $scope.openToDate = function () {
            $scope.popup2.opened = true;
        };

        if ($stateParams.authorEmp) {
            usSpinnerService.spin("root");
            DocumentsService.getEmployee($stateParams.authorEmp).then(function (emp) {
                $scope.authorEmp = {
                    _id: emp.profile,
                    user: emp.user,
                    positionInfo: {
                        position: emp.position,
                        organization: emp.organization
                    }
                };
                usSpinnerService.stop("root");
            });
        }

        if ($stateParams.authorSt) {
            usSpinnerService.spin("root");
            Students.listEmployee({ _id: $stateParams.authorSt }).then(function (res) {
                $scope.authorSt = res.docs[0];
                usSpinnerService.stop("root");
            });
        }

        if ($stateParams.authorOrg) {
            usSpinnerService.spin("root");
            DocumentsService.sendersList({ query: $stateParams.authorOrg }).then(function (senders) {
                if (!senders.length) {
                    return;
                }
                $scope.authorOrg = senders[0];
                usSpinnerService.stop("root");
            });
        }

        var socket = new Socket("/documents");

        socket.on('inbox', function (document) {
            $scope.documents.unshift(document)
            $scope.totalItems = $scope.documents.length;
        });

        DocumentsService.typeList({ admin: true }).then(function (data) {
            $scope.documentTypesMap = _.keyBy(data, '_id');
            data.forEach(function (type) {
                if (type.status) $scope.documentTypes[type.parentId].active.push(type)
                else $scope.documentTypes[type.parentId].deleted.push(type)
            });
            $scope.type = $stateParams.type || null;
        }).catch(function () {
            usSpinnerService.spin("root");
            toastr.error('', 'დაფიქსირდა შეცდომა');
        });

        $scope.applyFilter = function () {
            $state.go(".", {
                query: $scope.query,
                parentType: $scope.parentType,
                type: $scope.type,
                state: $scope.state,
                fromDate: $scope.fromDate,
                toDate: $scope.toDate,
                uniqueNumber: $scope.uniqueNumber,
                actionRequired: $scope.actionRequired,
                authorEmp: $scope.authorEmp ? $scope.authorEmp._id : null,
                authorSt: $scope.authorSt ? $scope.authorSt._id : null,
                authorOrg: $scope.authorOrg ? $scope.authorOrg.id : null,
            });
        };

        $scope.loadPage = function () {
            usSpinnerService.spin("root");
            DocumentsService.incomingList({
                page: $stateParams.page,
                limit: $scope.itemsPerPage,
                query: $scope.query,
                parentType: $scope.parentType,
                type: $scope.type,
                state: $scope.state,
                fromDate: $scope.fromDate,
                toDate: $scope.toDate,
                uniqueNumber: $scope.uniqueNumber,
                actionRequired: $scope.actionRequired,
                authorEmp: $scope.authorEmp && $scope.authorEmp._id ? $scope.authorEmp._id : $scope.authorEmp,
                authorSt: $scope.authorSt && $scope.authorSt._id ? $scope.authorSt._id : $scope.authorSt,
                authorOrg: $scope.authorOrg && $scope.authorOrg.id ? $scope.authorOrg.id : $scope.authorOrg,
            }).then(function (res) {
                $scope.documents = res.data.docs;
                $scope.workerId = res.data.workerId;
                $scope.totalItems = res.data.total;
                $scope.currentDocsCount = res.data.currentDocsCount;
                $scope.currentPage = $stateParams.page;
                usSpinnerService.stop("root");
            });
        };

        $scope.loadPage();

        $scope.changePage = function () {
            $state.go(".", { page: $scope.currentPage });
        };

        $scope.open = function (actionType, doc, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            $state.go('employee.documents.view', { documentId: doc.document._id, actionType: actionType, status: doc.status, infoId: doc._id, returnUrl: window.location.href })
        };

        $scope.select = function (docId, $event) {
            if ($event) {
                $event.stopPropagation();
            }
        };

        $scope.download = function (url, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            window.open(url);
        };

        $scope.getEmployees = function (name) {
            if (name.length < 1) {
                return [];
            }
            return DocumentsService.staffList({
                query: name
            }).then(function (data) {
                return data.docs;
            });
        };

        $scope.getStudents = function (name) {
            if (name.length < 1) {
                return [];
            }
            return Students.listEmployee({ query: name }).then(function (res) {
                return res.docs;
            });
        };

        $scope.getSenders = function (query) {
            if (query.length < 1) {
                return [];
            }
            return DocumentsService.sendersList({ query: query });
        };


        $scope.generateState = function (doc) {
            return !!(doc.deadline && doc.status !== 'done' && (new Date(doc.deadline) < new Date()));
        };

        $scope.generateStateClass = function (doc) {
            if (new Date().getTime() > new Date(doc.deadline).getTime() && doc.status !== 'done') return 'doc-returned';
            else return 'doc-done';
        };

        $scope.generateClass = function (status) {
            if (!status || status === 'unread') return 'doc-unread';
            if (status === 'done') return 'doc-done';
            if (status === 'read') return 'doc-read';
            if (status === 'returned') return 'doc-returned';
        };

        $scope.generateTooltip = function (doc) {
            if (doc.document.status === 'done' || doc.document.status === 'returned') return $scope.generation(doc);
            if (doc.document.resolvers && doc.document.resolvers.length) {
                for (var i in doc.document.resolvers) {
                    if ($scope.workerId !== doc.document.resolvers[i]._id) {
                        return $scope.generation(doc);
                    } else {
                        return 'გადამისამართებული';
                    }
                }
            } else {
                return $scope.generation(doc)
            }
        };

        $scope.generateText = function (doc) {
            if (new Date().getTime() > new Date(doc.deadline).getTime() && doc.status !== 'done') return 'შესრულების ვადა გასულია !';
            if (new Date().getTime() < new Date(doc.deadline).getTime() && doc.status !== 'done') return 'შესრულების ვადა : ' + new Date(doc.deadline).toLocaleDateString();
        };

        $scope.generation = function (doc) {
            var status = doc.status;

            if (!status || status === 'unread') return 'წაუკითხავი';
            if (status === 'done') return 'შესრულებული';
            if (status === 'read') return 'წაკითხული';
            if (status === 'returned') return 'მიბრუნებული';
        }

        $scope.getSender = function (doc) {
            if (doc.document.author && doc.document.author.user) {
                return doc.document.author.user.firstName + " " + doc.document.author.user.lastName;
            }
            return doc.document.senders.map(function (sender) { return sender.name; }).toString()
        }
    }
]);
